import { useContext, useEffect, useState } from "react";

import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Grid,
  Tooltip,
  Switch,
  FormControlLabel,
} from "@material-ui/core";

import TextFieldErp from "../../../../components/basics/TextFieldErp";
import Card from "../../../../components/cards/Card";
import SelectErp from "../../../../components/basics/SelectErp";
import useClienteController from "../controllers/ClienteController";
import { ClienteContext } from "../contexts/ClienteContext";
import TableDefault from "../../../../components/grid/TableDefault";
import ModalClienteInfoBancaria from "./ModalClienteInfoBancaria";
import { Margin } from "../../../../theme/styles/Utils";
import {
  CustomChip,
  HeaderAccordion,
  IconButtonStyled,
  TableContent,
} from "../styles/Cliente";
import Chip from "../../../../components/basics/Chip";
import SpeedDialErp from "../../../../components/speeddial/SpeedDialErp";
import {
  DeleteOutlined,
  ExpandMore as ExpandMoreIcon,
  EditOutlined as EditOutlinedIcon,
  Check as CheckIcon,
  Add as AddIcon,
} from "@material-ui/icons";

const columns = [
  {
    id: "acoes",
    label: "Ações",
    align: "center",
  },
  {
    id: "conta_padrao",
    label: "Principal",
    format: (item) => item.conta_padrao && <CheckIcon />,
  },
  {
    id: "nome",
    label: "Banco",
  },
  {
    id: "agencia",
    label: "Agência",
  },

  {
    id: "conta",
    label: "Conta",
  },
  {
    id: "chave_pix",
    label: "Chave Pix",
  },
  {
    id: "tipo_pix",
    label: "Tipo",
  },
];

const valid = false;

export default function AccordionClienteInfoFinanceira() {
  const {
    hasRestriction,
    setHasRestriction,
    hasLimit,
    setHasLimit,
    lastSearchSerasa1,
    setLastSearchSerasa1,
    lastSearchSerasa2,
    setLastSearchSerasa2,
    lastSearchSerasa3,
    setLastSearchSerasa3,
    limitValue,
    setLimitValue,
    generateCommission,
    setGenerateCommission,
    riskClass,
    setRiskClass,
    financialObservation,
    setFinancialObservation,
    billingAlert,
    setBillingAlert,
    minimumOrder,
    setMinimumOrder,
    bankInformations,
    setBankInformations,
    irWithheld,
    setIrWithheld,
    issWithheld,
    setIssWithheld,

    loadingInputs,
    expanded,
    listRiskClass,
    listBank,
    errors,
  } = useContext(ClienteContext);
  const {
    handleChangeOpenAcordion,
    handleRemoveItemTable,
    handleEditItemTable,
  } = useClienteController();
  const [dataTable, setDataTable] = useState([]);
  const [open, setOpen] = useState(false);
  const [rowEdit, setRowEdit] = useState(null);

  useEffect(() => {
    (async () => {
      const newList = [];
      bankInformations.forEach((item, index) => {
        const bankItem = listBank.find(
          (bank) => bank.codigo === item.codigo_banco
        );

        return (newList[index] = {
          ...item,
          nome: bankItem?.nome ?? "",
          acoes: (
            <SpeedDialErp
              actions={[
                {
                  icon: <EditOutlinedIcon />,
                  name: "Editar",
                  action: () =>
                    handleEditItemTable(setOpen, setRowEdit, item, index),
                },
                {
                  icon: <DeleteOutlined />,
                  name: "Excluir",
                  action: () =>
                    handleRemoveItemTable(
                      setBankInformations,
                      setDataTable,
                      bankInformations,
                      index
                    ),
                },
              ]}
            />
          ),
        });
      });

      setDataTable(newList);
    })();
  }, [
    bankInformations,
    handleEditItemTable,
    handleRemoveItemTable,
    listBank,
    setBankInformations,
  ]);

  const handleOpenModal = () => {
    setOpen(true);
  };

  return (
    <>
      {open && (
        <ModalClienteInfoBancaria
          open={open}
          setOpen={setOpen}
          rowEdit={rowEdit}
          setRowEdit={setRowEdit}
        />
      )}
      <Grid item xs={12}>
        <Accordion
          expanded={expanded.infoFinancial || false}
          onChange={() => handleChangeOpenAcordion("infoFinancial")}
        >
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel1bh-content"
            id="panel1bh-header"
          >
            <HeaderAccordion>
              <Grid container>
                <Grid item xs={12}>
                  <Chip
                    label="INFORMAÇÕES FINANCEIRAS / FISCAIS"
                    bgcolor={
                      !expanded.infoFinancial &&
                      errors.accordions &&
                      errors.accordions.includes("infoFinancial")
                        ? "red"
                        : "default"
                    }
                    textcolor={
                      !expanded.infoFinancial &&
                      errors.accordions &&
                      errors.accordions.includes("infoFinancial")
                        ? "white"
                        : "default"
                    }
                  />
                </Grid>
              </Grid>
            </HeaderAccordion>
          </AccordionSummary>
          <AccordionDetails>
            <Grid container spacing={2}>
              <Grid item container spacing={2}>
                <Grid item lg={3} md={4} sm={6} xs={6}>
                  <Card line="left">
                    <Grid container xs={12}>
                      <Grid item xs={12}>
                        <TextFieldErp
                          helperText={errors.lastSearchSerasa1 || ""}
                          error={errors.lastSearchSerasa1 ? true : false}
                          label="Últimas consultas ao serasa"
                          value={lastSearchSerasa1}
                          setValue={setLastSearchSerasa1}
                          type="date"
                        />
                      </Grid>

                      <Grid item xs={12}>
                        <TextFieldErp
                          helperText={errors.lastSearchSerasa2 || ""}
                          error={errors.lastSearchSerasa2 ? true : false}
                          label="Últimas consultas ao serasa"
                          value={lastSearchSerasa2}
                          setValue={setLastSearchSerasa2}
                          type="date"
                        />
                      </Grid>

                      <Grid item xs={12}>
                        <TextFieldErp
                          helperText={errors.lastSearchSerasa3 || ""}
                          error={errors.lastSearchSerasa3 ? true : false}
                          label="Últimas consultas ao serasa"
                          value={lastSearchSerasa3}
                          setValue={setLastSearchSerasa3}
                          type="date"
                        />
                      </Grid>
                    </Grid>
                  </Card>
                </Grid>

                <Grid item xs={12} sm={6} md={3}>
                  <Card line="left">
                    <Grid flex={1}>
                      <Margin margin="5 0 5 0">
                        <Grid item xs={12}>
                          <FormControlLabel
                            value="end"
                            control={
                              <Switch
                                checked={hasRestriction}
                                onChange={() =>
                                  setHasRestriction((current) => !current)
                                }
                                color="primary"
                              />
                            }
                            label="Possui Restrição"
                            labelPlacement="end"
                          />
                        </Grid>
                      </Margin>

                      <Margin margin="5 0 5 0">
                        <Grid item xs={12}>
                          <FormControlLabel
                            value="end"
                            control={
                              <Switch
                                checked={hasLimit}
                                onChange={() =>
                                  setHasLimit((current) => !current)
                                }
                                color="primary"
                              />
                            }
                            label="Possui Limite"
                            labelPlacement="end"
                          />
                        </Grid>
                      </Margin>

                      <Margin margin="5 0 5 0">
                        <Grid item xs={12}>
                          <FormControlLabel
                            value="end"
                            control={
                              <Switch
                                checked={generateCommission}
                                onChange={() =>
                                  setGenerateCommission((current) => !current)
                                }
                                color="primary"
                              />
                            }
                            label="Gera Comissão"
                            labelPlacement="end"
                          />
                        </Grid>
                      </Margin>
                    </Grid>
                  </Card>
                </Grid>

                <Grid item container lg={6} md={5} sm={12} xs={12} spacing={1}>
                  <Grid item lg={12} md={12} sm={12} xs={12}>
                    <TextFieldErp
                      disabled={!hasLimit}
                      label="Valor do Limite"
                      maxLength={13}
                      value={limitValue}
                      setValue={setLimitValue}
                      mask="decimal"
                    />
                  </Grid>

                  {valid && (
                    <Grid item lg={6} md={12} sm={12} xs={12}>
                      <SelectErp
                        loading={loadingInputs.listRiskClass || false}
                        helperText={errors.riskClass || ""}
                        error={errors.riskClass ? true : false}
                        label="Classe de Risco"
                        value={riskClass}
                        setValue={setRiskClass}
                        optionsList={listRiskClass}
                        descriptionField="descricao"
                      />
                    </Grid>
                  )}

                  <Grid item lg={12} md={12} sm={12} xs={12}>
                    <TextFieldErp
                      label="Valor Pedido Mínimo"
                      maxLength={13}
                      value={minimumOrder}
                      setValue={setMinimumOrder}
                      mask="decimal"
                    />
                  </Grid>

                  <Grid item lg={12} md={12} sm={12} xs={12}>
                    <TextFieldErp
                      label="Alerta de Faturamento"
                      maxLength={150}
                      value={billingAlert}
                      setValue={setBillingAlert}
                    />
                  </Grid>

                  <Grid item lg={3} md={3} sm={6} xs={12}>
                    <TextFieldErp
                      label="IR Retido (%)"
                      maxLength={6}
                      value={irWithheld}
                      setValue={setIrWithheld}
                      mask="decimal"
                    />
                  </Grid>

                  <Grid item lg={3} md={3} sm={6} xs={12}>
                    <TextFieldErp
                      label="ISS Retido (%)"
                      maxLength={6}
                      value={issWithheld}
                      setValue={setIssWithheld}
                      mask="decimal"
                    />
                  </Grid>

                  <Grid item xs={12}>
                    <TextFieldErp
                      label="Observação"
                      maxLength={255}
                      value={financialObservation}
                      setValue={setFinancialObservation}
                      multiline
                    />
                  </Grid>
                </Grid>
              </Grid>

              <Grid item container lg={12}>
                <TableContent>
                  <Grid item lg={12}>
                    <TableDefault
                      columns={columns}
                      values={dataTable}
                      tableTitle={
                        <Grid
                          container
                          spacing={1}
                          style={{ alignItems: "center" }}
                        >
                          <Grid item xs>
                            <CustomChip
                              label={
                                <p className="MuiChip-label">
                                  INFORMAÇÕES BANCÁRIAS
                                </p>
                              }
                            />
                          </Grid>

                          <Grid item flex={1}>
                            <Tooltip title="Adicionar">
                              <IconButtonStyled onClick={handleOpenModal}>
                                <AddIcon />
                              </IconButtonStyled>
                            </Tooltip>
                          </Grid>
                        </Grid>
                      }
                    />
                  </Grid>
                </TableContent>
              </Grid>
            </Grid>
          </AccordionDetails>
        </Accordion>
      </Grid>
    </>
  );
}
